export default __webpack_public_path__ + "static/media/hero 222.27c71c25.jpg";